<template>
	<div class="media-library-details absolute inset-0 bg-black">
		<img class="absolute inset-0 s-fill" src="@/assets/images/media-library-bg.jpg">
		<div class="svg s-fill" v-if="svg" v-html="svg"></div>

		<!-- List -->
		<div class="media-library-screen absolute p-4 overflow-auto">
			<div class="flex mb-2">
				<img class="w-6 h-5 mr-2" src="@/assets/images/search-icon.svg">
				<input class="flex-grow placeholder-black" type="text" name="search" placeholder="Rechercher un média" v-model="search">
			</div>

			<div class="pl-8">
				<table class="w-full text-left">
					<tbody>
						<tr v-for="scenario in mediaByScenario" :key="scenario.id">
							<td>
								<div>
									<p class="font-main-bold border-b border-gray-light pt-4 pb-2">
										{{scenario.name}}
									</p>
									<table class="w-full text-left">
										<tbody>
											<tr v-for="media in getMediaList(scenario)" :key="media.node_content">
												<td class="pl-6" @click="mediaClick(media)">
													<div class="border-b border-gray-light pt-4 pb-2 cursor-pointer">
														<img class="inline w-5 mr-2" v-if="media.type.slug == 'media'" src="@/assets/images/media-dark-icon.svg">
														<img class="inline h-5 w-5 mr-2" v-else-if="media.type.slug == 'pdf'" src="@/assets/images/pdf-dark-icon.svg">
														<span>
															{{media.title}}
														</span>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- Modal -->
		<div class="media-library__scenario-modal-container absolute flex flex-col items-center justify-center" v-if="currentPDF || currentMedia">
			<div
			class="absolute media-library-modal bg-white 
			rounded-md shadow-dark z-10 flex flex-col mb-28">

				<!-- Modal Header -->
				<div class="media-library-modal-header relative z-1">
					<!-- PDF Header -->
					<PDFViewHeader
					v-if="currentPDF"
					:title="currentPDF.title"
					:pdf="currentPDF"
					@previous="previousPDFPage()"
					@next="nextPDFPage()"
					@close="currentPDF = null"/>

					<!-- Game Header -->
					<MediaPlayerHeader
					v-else-if="currentMedia"
					:title="currentMedia.title"
					:media="currentMedia"
					:closable="true"
					@close="currentMedia = null" />
				</div>

				<!-- Modal content -->
				<div class="media-library-modal-content">
					<!-- PDF -->
					<PDFView 
					v-if="currentPDF" 
					:pdf="currentPDF" 
					ref="pdf" />

					<!-- Media node -->
					<MediaPlayer
					v-else-if="currentMedia"
					:media="currentMedia"
					ref="media"
					@next="currentMedia = null"
					@ended="currentMedia = null" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	
	import { mapState } from 'vuex'

	import soundEffectMixin from '@/mixins/soundEffectMixin'

	import PDFViewHeader from '@/components/scenario/modal/PDFViewHeader'
	import MediaPlayerHeader from '@/components/scenario/modal/MediaPlayerHeader'

	import PDFView from '@/components/scenario/modal/PDFView'
	import MediaPlayer from '@/components/scenario/modal/MediaPlayer'

	export default {
		name: 'MediaLibrary',
		mixins: [soundEffectMixin],
		components: {
			PDFViewHeader,
			MediaPlayerHeader,
			PDFView,
			MediaPlayer,
		},
		data() {
			return {
				search: '',
				svg: null,
				currentPDF: null,
				currentMedia: null,
				soundEffects: {
					book: require('../assets/sounds/media_library_book.mp3'),
				},
			}
		},
		computed: {
			...mapState('Assets', { mediaByScenario: 'media_list_by_scenario' }),
			...mapState('Assets', {
				assets(state) {
					if (!state.list || state.list.length <= 0)
						return {}

					return state.list.reduce((dict, asset) => {
						dict[asset.id] = asset

						return dict
					}, {})
				}
			}),
		},
		async mounted() {
			if (this.$store.state.Assets.list.length <= 0) {
				await this.$store.dispatch('Assets/getList')
			}
			
			if (this.$store.state.Assets.media_list_by_scenario.length <= 0) {
				await this.$store.dispatch('Assets/getMediaListByScenario')
			}

			// Send log data
			await this.$store.dispatch('Logs/save', {
				id: null,
				data_key: null,
				data: {},
				type_slug: 'visited_media_library',
			})

			const url = require('../assets/images/media-library-books.svg')
			
			// Load SVG content
			axios(url).then((response) => {
				this.svg = response.data

				// Add click listener to all overlay elements
				this.$nextTick(() => {
					const children = document.getElementById('faa-int').childNodes

					for (var i = 0; i < children.length; i++) {
						if (children[i].id) {
							children[i].addEventListener('click', this.bookClick)
						}
					}
				})
			})
		},
		methods: {
			getMediaList(scenario) {
				if (!this.search)
					return scenario.nodes

				return scenario.nodes.filter((node) => {
					return (node.title && node.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
				})
			},
			async mediaClick(node) {
				const asset = this.assets[node.node_content]
				
				asset.title = node.title

				if (asset.type.slug == 'file_pdf') {
					this.currentPDF = asset
				} else if (asset.type.slug == 'file_video') {
					this.currentMedia = asset
				}
			},
			async bookClick(evt) {
				this.playSoundEffect('book')

				const id = evt.currentTarget.id

				switch (id) {
					case '_01':
						window.open('https://drive.google.com/open?id=12oI5Nppmo91xGcWuvmuMdnYTYmu0oIvI&authuser=laurine.badache@afpols.fr&usp=drive_fs', '_blank')
						break

					case '_02':
						window.open('https://www.foph.fr/oph/Main/', '_blank')
						break

					case '_06':
						window.open('https://musee-hlm.fr/', '_blank')
						break

					case '_07':
						this.currentPDF = {
							title: 'Les chiffres clés du logement social',
							url: "/les_chiffres_cles_du_logement_social_2020.pdf",
							type: {
								slug: 'file_pdf'
							}
						}
						break

					case '_08':
						window.open('https://drive.google.com/open?id=12rFFmUhWkgxc2uHSzSyiKww9jyXmLpvQ&authuser=laurine.badache@afpols.fr&usp=drive_fs', '_blank')
						break

					case '_09':
						window.open('https://www.youtube.com/watch?v=LQ8LEh_WRTA&list=PLBj0PexXesuCTPyCo9B8fcW-Ks7kGOM7X', '_blank')
						break

					case '_03':
						window.open('https://drive.google.com/open?id=12u0_zjE_n6dmbhDtN3VX4UidYNjKeyKe&authuser=laurine.badache@afpols.fr&usp=drive_fs', '_blank')
						break

					case '_04':
						window.open('https://drive.google.com/open?id=12tAId9hC3iBR4HhBUyuvRtBwtW3nWV5R&authuser=laurine.badache@afpols.fr&usp=drive_fs', '_blank')
						break

					case '_05':
						window.open('https://www.union-habitat.org/glossaire-des-sigles-et-acronymes', '_blank')
						break

					case '_10':
						window.open('https://www.union-habitat.org/frise-historique', '_blank')
						break
				}
			},
			previousPDFPage() {
				if (this.$refs.pdf)
					this.$refs.pdf.previousPage()
			},
			nextPDFPage() {
				if (this.$refs.pdf)
					this.$refs.pdf.nextPage()
			},
		}
	}

</script>

<style lang="scss">

.media-library__scenario-modal-container {
	top: 70px;
	right: 0;
	bottom: 0;
	left: 0;
}

.media-library-details {
	svg {
		width: 100%;
		height: 100%;
		max-width: 100%;
		max-height: 100%;

		& > * {
			pointer-events: none;
		}
	}

	#faa-int {
		pointer-events: none;
		transform: translateZ(0);

		& > * {
			pointer-events: all;
			transform: translateZ(0);
			cursor: pointer;
		}
	}
}

.media-library-screen {
	@apply bg-white rounded;

	top: 31.0129%;
	left: 31.4171%;
	width: 37.2%;
	height: 37.8%;
}

.media-library-modal { // todo: improve responsive
	width: 980px;
	max-width: 90%;
	max-height: 90%;

	&.media-modal {
		width: auto;
		max-width: 70%;
	}

	&-header {
		box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);// todo
	}

	&-content {
		overflow: auto;
		height: 100%;
	}
}

</style>